import { memo } from 'react';

import IconModal from '../../../../components/IconModal';
import Config from '../../../../config';

export interface IPwaPushPermissionDialogProps {
    open: boolean;
    busy?: boolean;
    onEnable: () => void;
    onClose: () => void;
}

export const PwaPushPermissionDialog = memo(
    ({ open, busy = false, onEnable, onClose }: IPwaPushPermissionDialogProps) => {
        return (
            <IconModal
                open={open}
                onClose={onClose}
                title="Benachrichtigungen aktivieren"
                text={`Erhalte Nachrichten und Likes von ${Config.GLOBAL_SITE_NAME} auch wenn die App geschlossen ist.`}
                button={{
                    title: busy ? 'Bitte warten…' : 'Aktivieren',
                    disabled: busy,
                    onClick: onEnable,
                }}
            />
        );
    }
);

export default PwaPushPermissionDialog;
